export default {
  name: 'share-it',
  props: {
    shareConfig: {
      type: Object,
      "default": function _default() {
        return {
          linkedin: {},
          twitter: {},
          facebook: {},
          whatsapp: {},
          reddit: {},
          email: {}
        };
      }
    },
    targets: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    text: {
      type: String,
      "default": ''
    },
    url: {
      type: String,
      "default": ''
    },
    width: {
      type: Number,
      "default": 600
    },
    height: {
      type: Number,
      "default": 600
    },
    dense: {
      type: Boolean,
      "default": false
    },
    dark: {
      type: Boolean,
      "default": false
    },
    icons: {
      type: Boolean,
      "default": false
    },
    outline: {
      type: Boolean,
      "default": false
    },
    round: {
      type: Boolean,
      "default": false
    },
    iconSize: {
      type: String,
      "default": 'lg'
    }
  },
  data: function data() {
    return {
      configObj: this.shareConfig || {},
      defaultIconSize: 'lg',
      defaultIconDimension: '2em'
    };
  },
  computed: {
    finalConfig: function finalConfig() {
      var vm = this;
      var baseConfig = {};
      if (vm.targets.length) {
        baseConfig = Object.keys(vm.configObj).filter(function (key) {
          return vm.targets.includes(key);
        }).reduce(function (obj, key) {
          obj[key] = vm.configObj[key];
          return obj;
        }, {});
      } else {
        baseConfig = vm.configObj;
      }
      for (var key in baseConfig) {
        if (!vm.configObj.hasOwnProperty(key)) continue;
        switch (key) {
          case 'twitter':
            baseConfig[key].platform = 'twitter';
            baseConfig[key].defaultIcon = 'twitter';
            baseConfig[key].defaultLabel = 'Twitter';
            baseConfig[key].defaultColor = '#FFFFFF';
            baseConfig[key].defaultBackground = '#1DA1F2';
            baseConfig[key].defaultIconColor = '#1DA1F2';
            break;
          case 'linkedin':
            baseConfig[key].platform = 'linkedin';
            baseConfig[key].defaultIcon = 'linkedin';
            baseConfig[key].defaultLabel = 'Linkedin';
            baseConfig[key].defaultColor = '#FFFFFF';
            baseConfig[key].defaultBackground = '#0077B5';
            baseConfig[key].defaultIconColor = '#0077B5';
            break;
          case 'facebook':
            baseConfig[key].platform = 'facebook';
            baseConfig[key].defaultIcon = 'facebook-f';
            baseConfig[key].defaultLabel = 'Facebook';
            baseConfig[key].defaultColor = '#FFFFFF';
            baseConfig[key].defaultBackground = '#3b5998';
            baseConfig[key].defaultIconColor = '#3b5998';
            break;
          case 'whatsapp':
            baseConfig[key].platform = 'whatsapp';
            baseConfig[key].defaultIcon = 'whatsapp';
            baseConfig[key].defaultLabel = 'Whatsapp';
            baseConfig[key].defaultColor = '#FFFFFF';
            baseConfig[key].defaultBackground = '#25d366';
            baseConfig[key].defaultIconColor = '#25d366';
            break;
          case 'reddit':
            baseConfig[key].platform = 'reddit';
            baseConfig[key].defaultIcon = 'reddit-alien';
            baseConfig[key].defaultLabel = 'Reddit';
            baseConfig[key].defaultColor = '#FFFFFF';
            baseConfig[key].defaultBackground = '#ff4500';
            baseConfig[key].defaultIconColor = '#ff4500';
            break;
          case 'email':
            baseConfig[key].platform = 'email';
            baseConfig[key].defaultIcon = 'envelope';
            baseConfig[key].defaultLabel = 'Email';
            baseConfig[key].defaultColor = '#FFFFFF';
            baseConfig[key].defaultBackground = '#333';
            baseConfig[key].defaultIconColor = '#333';
            break;
          default:
            baseConfig[key].platform = '';
            baseConfig[key].defaultIcon = '';
            baseConfig[key].defaultLabel = '';
        }
        if (baseConfig[key].icon || vm.icons) {
          baseConfig[key].iconSize = vm.getIconSize(baseConfig[key].size || vm.iconSize || vm.defaultIconSize);
        }
      }
      return baseConfig;
    }
  },
  methods: {
    openPopUp: function openPopUp(config) {
      var vm = this;
      var shareUrl = '';
      switch (config.platform) {
        case 'twitter':
          shareUrl = 'http://twitter.com/share';
          if (vm.url) {
            shareUrl += "?url=".concat(encodeURIComponent(vm.url));
          } else {
            shareUrl += "?url=".concat(encodeURIComponent(document.location.href));
          }
          if (config.text || vm.text) {
            shareUrl += "&text=".concat(encodeURIComponent(config.text || vm.text));
          }
          if (config.hashtags) {
            shareUrl += "&hashtags=".concat(encodeURIComponent(config.hashtags || ''));
          }
          break;
        case 'linkedin':
          shareUrl = 'https://www.linkedin.com/shareArticle?mini=true';
          if (vm.url) {
            shareUrl += "&url=".concat(encodeURIComponent(vm.url));
          } else {
            shareUrl += "&url=".concat(encodeURIComponent(document.location.href));
          }
          if (config.text || vm.text) {
            shareUrl += "&title=".concat(encodeURIComponent(config.text || vm.text));
          }
          if (config.summary) {
            shareUrl += "&summary=".concat(encodeURIComponent(config.summary || ''));
          }
          if (config.source) {
            shareUrl += "&source=".concat(encodeURIComponent(config.source || ''));
          }
          break;
        case 'facebook':
          shareUrl = 'https://facebook.com/sharer.php?display=popup';
          if (vm.url) {
            shareUrl += "&u=".concat(encodeURIComponent(vm.url));
          } else {
            shareUrl += "&u=".concat(encodeURIComponent(document.location.href));
          }
          break;
        case 'whatsapp':
          shareUrl = 'whatsapp://send?text=';
          if (config.text) {
            shareUrl += "".concat(encodeURIComponent(config.text), " ");
          } else {
            shareUrl += "".concat(encodeURIComponent(vm.text), " ");
          }
          if (vm.url) {
            shareUrl += "".concat(encodeURIComponent(vm.url));
          } else {
            shareUrl += "".concat(encodeURIComponent(document.location.href));
          }
          break;
        case 'reddit':
          shareUrl = 'http://www.reddit.com/submit';
          if (vm.url) {
            shareUrl += "?url=".concat(encodeURIComponent(vm.url));
          } else {
            shareUrl += "?url=".concat(encodeURIComponent(document.location.href));
          }
          if (config.text || vm.text) {
            shareUrl += "&title=".concat(encodeURIComponent(config.text || vm.text));
          }
          break;
        case 'email':
          shareUrl = 'mailto:';
          if (config.text || vm.text) {
            shareUrl += "?subject=".concat(encodeURIComponent(config.text || vm.text));
          } else {
            shareUrl += "?subject=Check out this website";
          }
          shareUrl += "&body=";
          if (config.summary) {
            shareUrl += "".concat(encodeURIComponent(config.summary || ''));
          }
          if (vm.url) {
            shareUrl += " ".concat(encodeURIComponent(vm.url));
          } else {
            shareUrl += " ".concat(encodeURIComponent(document.location.href));
          }
          break;
        default:
          shareUrl = false;
      }
      if (shareUrl) {
        window.open(shareUrl, 'popup', "width=".concat(vm.width, ",height=").concat(vm.height));
        vm.$emit('clicked', config.platform);
      }
      return false;
    },
    getIconSize: function getIconSize(size) {
      switch (size) {
        case 'xs':
          return '1.5em';
          break;
        case 'sm':
          return '1.75em';
          break;
        case 'lg':
          return '2em';
          break;
        case '2x':
          return '3em';
          break;
        case '3x':
          return '4.5em';
          break;
        case '4x':
          return '6em';
          break;
        case '5x':
          return '7em';
          break;
        case '6x':
          return '8.5em';
          break;
        case '7x':
          return '9.5em';
          break;
        case '8x':
          return '10.5em';
          break;
        case '9x':
          return '12em';
          break;
        case '10x':
          return '13em';
          break;
        default:
          return '2em';
      }
    }
  }
};